import { z } from "zod/v4";

import { OnsiteEditDtoDescriptions } from "../descriptions/onsite-edit-dto.describe";
import { ModificationSourceList } from "./modification-source";

export const InsertTypeList = [
  "beforebegin",
  "afterbegin",
  "beforeend",
  "afterend",
] as const;

export type InsertType = (typeof InsertTypeList)[number];

export const OnsiteEditTypeList = ["html", "text", "image", "hide"] as const;
export type OnsiteEditType = (typeof OnsiteEditTypeList)[number];

// Base object schema - exported for use in schemas that need .omit() or .extend()
export const OnsiteEditBaseSchema = z.object({
  id: z.uuid().describe(OnsiteEditDtoDescriptions.id),
  onsiteEditType: z
    .enum(OnsiteEditTypeList)
    .nullish()
    .describe(OnsiteEditDtoDescriptions.onsiteEditType),
  variationId: z.uuid().describe(OnsiteEditDtoDescriptions.variationId),
  find: z.string().nullable().describe(OnsiteEditDtoDescriptions.find),
  title: z.string().nullish().describe(OnsiteEditDtoDescriptions.title),
  isRegex: z
    .boolean()
    .default(false)
    .describe(OnsiteEditDtoDescriptions.isRegex),
  replace: z.string().default("").describe(OnsiteEditDtoDescriptions.replace),
  querySelectors: z
    .string()
    .array()
    .default([""])
    .describe(OnsiteEditDtoDescriptions.querySelectors),
  skip: z.boolean().default(false).describe(OnsiteEditDtoDescriptions.skip),
  remove: z.boolean().default(false).describe(OnsiteEditDtoDescriptions.remove),
  groupId: z.string().optional().describe(OnsiteEditDtoDescriptions.groupId),
  /**
   * @deprecated // use onsiteEditType instead
   */
  isHtml: z.boolean().default(false),
  /**
   * @deprecated // use onsiteEditType instead
   */
  isImage: z.boolean().default(false),
  insertType: z
    .enum(InsertTypeList)
    .nullable()
    .describe(OnsiteEditDtoDescriptions.insertType),
  createdAtUrl: z
    .string()
    .optional()
    .nullable()
    .describe(OnsiteEditDtoDescriptions.createdAtUrl),
  createdAtTs: z
    .number()
    .nullish()
    .describe(OnsiteEditDtoDescriptions.createdAtTs),
  imageSearchUrl: z
    .string()
    .optional()
    .nullable()
    .describe(OnsiteEditDtoDescriptions.imageSearchUrl),
  source: z.enum(ModificationSourceList).nullish(),
});

// DTO schema without refinements - safe for GET responses with existing data
export const OnsiteEditDtoSchema = OnsiteEditBaseSchema;
export type OnsiteEditDto = z.infer<typeof OnsiteEditDtoSchema>;
